/**
 * Длительности спецверсий для автоблоков сетки ДК (27.09).
 *
 * Гейт (conflicts.ts, eff()) считает бронь спецверсии по duration_min/reset_min ВЕРСИИ,
 * а сетка считала по базовому квесту: версия длиннее базы в связке оставляла соседу
 * «свободную» ячейку, которую гейт отбивал. Грузим версии один раз при открытии сетки —
 * вместе со снятыми (?archived=1): бронь на снятой версии стоит, и гейт её длительность
 * видит. Сбой запроса — пустой список: сетка падает к базовым длительностям, как раньше.
 */

import { useEffect, useState } from "react";
import { api } from "../api/client";
import type { ApiList, QuestVersion } from "../api/types";
import type { VersionSpan } from "./useGridData";

export function useVersionSpans(): VersionSpan[] {
  const [versions, setVersions] = useState<VersionSpan[]>([]);
  useEffect(() => {
    let live = true;
    api<ApiList<QuestVersion>>("/api/quest-versions?archived=1")
      .then((r) => { if (live) setVersions(r.results ?? []); })
      .catch(() => {});
    return () => { live = false; };
  }, []);
  return versions;
}
